var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4417 17.5C10.2952 17.7526 10.0849 17.9622 9.83185 18.1079C9.57884 18.2537 9.29198 18.3304 9 18.3304C8.70802 18.3304 8.42116 18.2537 8.16814 18.1079C7.91513 17.9622 7.70484 17.7526 7.55833 17.5M14 6.66666C14 5.34057 13.4732 4.0688 12.5355 3.13112C11.5979 2.19344 10.3261 1.66666 9 1.66666C7.67392 1.66666 6.40215 2.19344 5.46447 3.13112C4.52678 4.0688 4 5.34057 4 6.66666C4 12.5 1.5 14.1667 1.5 14.1667H16.5C16.5 14.1667 14 12.5 14 6.66666Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.9c228ef2fda0e4404a31f9c598c7a4e0.svg";
export { ForwardRef as ReactComponent };